import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { Box } from "@mui/material";
import "swiper/css";

export default function ClientsCarousel({ id, certificates = [] }) {
  const enableLoop = certificates.length >= 6;

  return (
    <Swiper
      modules={[Autoplay]}
      loop={enableLoop}
      speed={7000}
      autoplay={
        enableLoop
          ? { delay: 0, disableOnInteraction: false }
          : false
      }
      allowTouchMove
      spaceBetween={18}
      breakpoints={{
        0: { slidesPerView: 1.5 },
        480: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1000: { slidesPerView: 4 },
        1300: { slidesPerView: 5 },
      }}
      style={{ padding: "10px 4px 18px" }}
    >
      {certificates.map((item) => (
        <SwiperSlide key={item?.Id}>
          <Box
            sx={{
              height: { xs: 125, md: 145 },
              border: "1px solid #e8edf3",
              borderRadius: 4,
              bgcolor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 2.5,
              transition: "all .25s ease",
              "&:hover": {
                transform: "translateY(-4px)",
                borderColor: "#d8e0ea",
                boxShadow: "0 16px 35px rgba(15, 23, 42, .08)",
              },
            }}
          >
            <Box
              component="img"
              src={item?.Base64Certificate}
              alt="Certificação"
              sx={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                filter: "saturate(.9)",
              }}
            />
          </Box>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
